module.exports = __webpack_public_path__ + "img/icons-24-search.f523e650.svg";